export const DeliveryType = {
  PICKUP: "pickup",
  STORAGE: "storage",
  ADDRESS: "address",
  COURIER: "courier",
};

export const PaymentProcessType = {
  CARD_ONLINE: "card_online",
  PAY_WITH_DETAILS: "pay_with_details",
  ELECTRONIC: "electronic",
};

export const RecipientType = {
  ME: 0,
  ANOTHER: 1,
};

export const OrderType = {
  TRANSFER: "transfer",
  CLIENTSALE: "clientsale",
  SALE: "sale",
};
